// Utils
import { $qs, $qsa } from "./utils/QuerySelector";

// Animations
import twkScroll from "./animations/twkScroll";
import homeAnimation from "./animations/homeAnimations";
import contactAnimation from "./animations/contactAnimations";
import onScroll from "./animations/onScroll";

// Components
import accordion from "./components/accordion";
import logoSlider from "./components/logo-slider";
import newsSlider from "./components/news-quote-slider";
import imageSlider from "./components/image-slider";
import quoteSlider from "./components/quote-slider";

// Scripts
import { CountUp } from 'countup.js';
import gsap from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);


function init() {
  twkScroll();
  if ($qs("body.page-template-tpl-home")) {
    homeAnimation();
    // Scroll to top of page on reload so top of homepage animation works properly
    window.onbeforeunload = function () {
      window.scrollTo(0, 0);
    }
  } 
  if ($qs("body.page-template-tpl-contact")) contactAnimation();
  accordion();
  logoSlider();
  newsSlider();
  imageSlider();
  quoteSlider();
  onScroll();
}
init();


jQuery(document).ready(function ($) {
  

  consoleMessage: {
    console.log(
      "%cCreated by %cTWK%cwww.thewebkitchen.co.uk",
      "background: #13212E; color: #FFFFFF; padding: 5px 0px 5px 10px; margin: 25px 0px;",
      "background: #13212E; color: #05E5C8; padding: 5px 10px 5px 0px; font-weight: bold;",
      "background: #FFFFFF; padding: 5px 10px;"
      );
    }
        
    
  menu: {
    // Open menu
    $('.js-menu-button').on('click', function(e) {
      $(this).toggleClass('is-active');
      $('.js-menu-link').toggleClass('is-active');
      $('.menu-wrapper').toggleClass('is-active');
      $('.sub-menu').removeClass('is-active');
    });
    
    // Accordion menu
    function accordionMenu(menuClass) {
      var menuName = menuClass; 
      if ( $(menuName).find('.menu > li').hasClass('current_page_ancestor') ) {
        $(menuName).find('.menu > li.current_page_ancestor').children('.sub-menu').slideDown().addClass('is-active');
        $(menuName).find('.menu > li.current_page_ancestor').addClass('is-active');
      }
      $(menuName).find('.menu > .menu-item-has-children > a').on('click', function(e){
        e.preventDefault();
        if ( $(this).next().hasClass('is-active') ) {
          $(menuName).find('.sub-menu').removeClass('is-active');
          $(menuName).find('.menu > li').removeClass('is-active');
          $(menuName).find('.sub-menu').slideUp();
        } else {
          $(menuName).find('.sub-menu').removeClass('is-active');
          $(menuName).find('.menu > li').removeClass('is-active');
          $(menuName).find('.sub-menu').slideUp();
          $(this).next().addClass('is-active');
          $(this).parent().addClass('is-active');
          $(this).next().slideDown();
        }
      });
    }
    // Secondary menu accordion
    accordionMenu('.menu-secondary-menu-container');

     // Turn regular menus into accordions on smaller screen sizes
     if ( window.matchMedia('(min-width: 640px)').matches && window.matchMedia('(max-width: 1099px)').matches || window.matchMedia('(max-height: 885px)').matches && window.matchMedia('(min-width: 640px)').matches ) { 
      accordionMenu('.menu-main-menu-left-container');
      accordionMenu('.menu-main-menu-right-container');
    }


    // Mobile menu
    function mobileSubNav(menuClass) {
      var menuName = menuClass; 
      
      // Open sub-nav on click on menu item with children
      $(menuName).find(".menu-item-has-children > a").on("click", function(e) {
        e.preventDefault();
        $(this).parent().find('.sub-menu').toggleClass('is-active');
      });
      // Close sub-nav on click on back button
      $(menuName).find(".menu-item-has-children .js-back-button").on("click", function(e) {
        e.preventDefault();
        $(this).parent().parent().toggleClass('is-active');
      });
    }
    if ( window.matchMedia('(max-width: 640px)').matches ) {
      mobileSubNav('.menu-main-menu-left-container');
      mobileSubNav('.menu-main-menu-right-container');
    }
    
    
  }

  anchorlinks: {
    $(document).on("click", ".scroll-to", function (event) {
      event.preventDefault();

      $("html, body").animate(
        {
          scrollTop: $($.attr(this, "href")).offset().top,
        },
        500
      );
    });
  }

  externallinks: {
    $('a[href^="mailto:"]').each(function () {
      $(this).addClass("email-link");
    });

    /*
    $('a:not(.email-link):not([class^="magnific-"])').each(function () {
      var a = new RegExp("/" + window.location.host + "/");

      if (!a.test(this.href)) {
        $(this).click(function (event) {
          event.preventDefault();
          window.open(this.href, "_blank");
        });
      }
    });
    */
    pdfs: {
      // Open PDFs in new window
      $(function () {
        $('a[href$=".pdf"]').prop("target", "_blank");
      });
    }
  }

  slider: {

    


  }

  magnific: {
    // IFRAME
    $(".magnific-video").magnificPopup({
      type: "iframe",
      mainClass: "mfp-video-wrapper",
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false,

      iframe: {
        markup:
          '<div class="mfp-iframe-scaler">' +
          '<div class="mfp-close"></div>' +
          '<iframe class="mfp-iframe" frameborder="0" allow="autoplay" allowfullscreen></iframe>' +
          "</div>",
        patterns: {
          youtu: {
            index: "youtu.be",
            id: function (url) {
              // Capture everything after the hostname, excluding possible querystrings.
              var m = url.match(/^.+youtu.be\/([^?]+)/);

              if (null !== m) {
                return m[1];
              }

              return null;
            },
            // Use the captured video ID in an embed URL.
            // Add/remove querystrings as desired.
            src: "//www.youtube.com/embed/%id%?autoplay=1&rel=0",
          },
          youtube: {
            index: "youtube.com/",
            id: "v=",
            src: "https://www.youtube.com/embed/%id%?autoplay=1",
          },
        },
      },
    });

    // INLINE
    $(".magnific-inline-popup").magnificPopup({
      type: "inline",

      fixedContentPos: false,
      fixedBgPos: true,

      overflowY: "auto",

      closeBtnInside: true,
      preloader: false,

      midClick: true,
      removalDelay: 300,
      mainClass: "my-mfp-zoom-in",
    });

    //detects when the ajax request has finished and the content has been updated
    $(document).on("sf:ajaxfinish", ".searchandfilter", function(){
      $(".magnific-inline-popup").magnificPopup({
        type: "inline",

        fixedContentPos: false,
        fixedBgPos: true,

        overflowY: "auto",

        closeBtnInside: true,
        preloader: false,

        midClick: true,
        removalDelay: 300,
        mainClass: "my-mfp-zoom-in",
      });
    });

    // GALLERY SINGLE IMAGE
    $(".magnific-gallery-single-image").magnificPopup({
      type: "image",
      closeOnContentClick: true,
      mainClass: "mfp-img-single",
      image: {
        verticalFit: true,
        titleSrc: function titleSrc(item) {
          return item.el.attr("title");
        },
      },
      gallery: {
        enabled: false,
      },
    });

    // GALLERY IMAGE
    $(".magnific-gallery-image").magnificPopup({
      type: "image",
      closeOnContentClick: true,
      mainClass: "mfp-img-mobile",
      image: {
        verticalFit: true,
        titleSrc: function (item) {
          return item.el.attr("title");
        },
      },
      gallery: {
        enabled: true,
      },
    });

    $('.prose .row .col-6 > a').on('click', function(e) {
      e.preventDefault();
      console.log('clicked');
    });
    $(".prose .row").magnificPopup({
      delegate: 'a',
      type: "image",
      closeOnContentClick: true,
      mainClass: "mfp-img-mobile",
      image: {
        verticalFit: true,
        titleSrc: function (item) {
          return item.el.attr("title");
        },
      },
      gallery: {
        enabled: true,
      },
    });
  }

  tables: {
    $('table').wrap('<div class="tablewrapper"></div>');
  }


  statCountUps: {

    if ( $('.js-stats-block').length ) {
      const statOne = $('#stat-1').data('number');
      let statOneSuffix = $('#stat-1').data('suffix');
      if ( !statOneSuffix ) { statOneSuffix = ''; } 
      const countUpOne = new CountUp('stat-1', statOne, { enableScrollSpy: true, suffix: statOneSuffix, separator: '', });
  
      const statTwo = $('#stat-2').data('number');
      let statTwoSuffix = $('#stat-2').data('suffix');
      if ( !statTwoSuffix ) { statTwoSuffix = ''; }
      const countUpTwo = new CountUp('stat-2', statTwo, { enableScrollSpy: true, suffix: statTwoSuffix, separator: '', });
  
      const statThree = $('#stat-3').data('number');
      let statThreeSuffix = $('#stat-3').data('suffix');
      if ( !statThreeSuffix ) { statThreeSuffix = ''; }
      const countUpThree = new CountUp('stat-3', statThree, { enableScrollSpy: true, suffix: statThreeSuffix, separator: '', });
    }

  }


  scrollTabs: {
    if ( window.matchMedia('(min-width: 768px)').matches ) {
      $(window).scroll(function () {

        
        var scrollTop = $(document).scrollTop();
        var panels = $('body').find('.scroll-tabs__panel');
        
        for (var i = 0; i < panels.length; i++) {
          if (scrollTop > $(panels[i]).offset().top - 500 && scrollTop < $(panels[i]).offset().top + $(panels[i]).height() - 500) {
            $('#' + $(panels[i]).attr('id')).addClass('active');
            $('#' + $(panels[i]).data('number')).addClass('active');
          } else if ( scrollTop < $('#panel-1').offset().top ) {
            $('#panel-1').addClass('active');
            $('#number-1').addClass('active');
          } else {
            $('#' + $(panels[i]).attr('id')).removeClass('active');
            $('#' + $(panels[i]).data('number')).removeClass('active');
          }
        }
        
      });
    }
  }

  
  stickyScroll: {
    // Vacancy sidebar sticky
    if (document.querySelectorAll('[data-js="sticky-scroll"]').length) {
      if (window.matchMedia('(max-width: 991px)').matches) {
        return;
      }       

      let st = ScrollTrigger.create({
        trigger: "[data-js='sticky-scroll-contain']",
        pin: "[data-js='sticky-scroll']",
        pinSpacing: false,
        start: "250px start",
        end: "107% bottom",
      });
    }

    // Faculties inner title sticky
    if (document.querySelectorAll('[data-js="sticky-scroll-title"]').length) {
      if (window.matchMedia('(max-width: 1099px)').matches) {
        return;
      }       

      let st = ScrollTrigger.create({
        trigger: "[data-js='sticky-scroll-contain']",
        pin: "[data-js='sticky-scroll-title']",
        pinSpacing: false,
        start: "250px start",
        end: "95% 50%",
      });
    }
  }


  stickySidebars: {
    if ( $('.js-sticky-title').length ) {
      var stickyTitle = $('.js-sticky-title').offset().top;
      $(window).scroll(function() {
        var windowTop = $(window).scrollTop();
        if (stickyTitle < windowTop && $(".js-sticky-wrapper").height() + $(".js-sticky-wrapper").offset().top - $(".js-sticky-title").height() > windowTop) {
          $('.js-sticky-title').css('position', 'fixed');
          $('.js-sticky-title').css('top', '0px');
        } else {
          $('.js-sticky-title').css('position', 'absolute');
          $('.js-sticky-title').css('top', '250px');
        }
      });
    }
  }


  loadingAnimations: {
    $.fn.isOnScreen = function () {
      var win = $(window);
      var viewport = {
        top: win.scrollTop(),
      };
      viewport.bottom = viewport.top + win.height() - 80;

      var bounds = this.offset();
      bounds.bottom = bounds.top + this.outerHeight();

      return !(viewport.bottom < bounds.top || viewport.top > bounds.bottom);
    };

    // First load Animation
    $(".off-screen").each(function (index) {
      if ($(this).isOnScreen()) {
        $(this).removeClass("off-screen--hide");
      }
    });

    // Animation on scroll
    $(window).scroll(function () {
      $(".off-screen").each(function (index) {
        if ($(this).isOnScreen()) {
          $(this).removeClass("off-screen--hide");
        }
      });
    });
  }
});
